import {Label} from "@irati/ui/src/Typography"
import React, {FC} from "react"
import styled from "styled-components"

interface Props {
  status: string
}

const Wrapper = styled.div`
  border-radius: ${({theme}) => theme.spacing.half};
  display: flex;
  justify-content: center;
  width: max-content;
  padding: ${({theme}) => `${theme.spacing.half} ${theme.spacing.one}`};
  background-color: ${({theme}) => theme.colors.greys.grey03};
`

const StatusPill: FC<Props> = ({status}) => {
  return (
    <Wrapper>
      <Label uppercase weight="bold">
        {status}
      </Label>
    </Wrapper>
  )
}

export default StatusPill
